import { connect } from "react-redux";
// @ts-ignore надо обновить moduleResolution до nodenext
import { FiasSchema, FiasComboBoxProps } from "@skbkontur/fias-widget-npm-loader";

import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withFocusOnNextValueEditor } from "../../../Helpers/JumpByEnterOnNextControl/WithFocusOnNextValueEditor";
import { checkIsSuitableToClick, externalOnClickHandler } from "../../../Engine/ActionCreators/ExternalOnClickAction";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";

import { ParsedExtendedFiasField } from "./FiasInput/Types/FiasTypes";
import {
    extractFssAddressFromBindingPath,
    FiasAddress,
    fiasComponentIdExtractor,
    getFiasControlModel,
    setFiasAddressToModel,
} from "./Utils/FiasAddressUtils";
import { Fias } from "./Fias";
import { AbbreviationTypes } from "./FiasInput/Types/AbbreviationSize";

export interface ChildrenOptions {
    childrenInStack: number;
    path: string;
}

export interface FnsOptions {
    extendModal: boolean;
    withFederalTerritory: boolean;
    withIndex: boolean;
    abbreviationSize: AbbreviationTypes;
    hiddenFields: FiasFnsFields[];
}

export enum FiasFnsFields {
    Region = "Region",
    District = "District",
    Settlement = "Settlement",
    City = "City",
    Structure = "Structure",
    Street = "Street",
    Stead = "Stead",
    House = "House",
    Housing = "Housing",
    Building = "Building",
    Apartment = "Apartment",
    Room = "Room",
    Id = "Id",
}

export interface MvdOptions {
    extendModal: boolean;
}

export interface AdrGarOptions {
    extendModal: boolean;
    fiasSchema: FiasSchema;
    divisionSelector: boolean;
    viewMode: Required<FiasComboBoxProps["viewMode"]>;
    countrySelector: boolean;
    menuAlign?: "left" | "right";
    countryCode: string;
}

export interface FiasContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
    title: string;
    withForeignCountry: boolean;
    pathToFullAddress?: string;
    extendedFields: ParsedExtendedFiasField[];
    childrenOptions?: ChildrenOptions;
    fnsOptions?: FnsOptions;
    mvdOptions?: MvdOptions;
    adrGarOptions?: AdrGarOptions;
    clearSubstring?: string;
}

const mapStateToProps = (
    state: FullFormState,
    { bindingPath, viewModelSelect, extendedFields }: FiasContainerProps
) => {
    const fssFiasAddress = extractFssAddressFromBindingPath(viewModelSelect, state, bindingPath, extendedFields);
    const controlModel = getFiasControlModel(viewModelSelect, state, bindingPath, extendedFields);
    return {
        value: fssFiasAddress,
        baseUrl: state.settings.keformsUrl,
        isReadOnly: state.settings.isReadOnly,
        isLink: checkIsSuitableToClick(state.settings, bindingPath),
        error: controlModel.error,
        warning: controlModel.warning,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, fiasProps: FiasContainerProps) => ({
    onValueChange: (nextValue: FiasAddress) => {
        dispatch((_, __, form) => {
            form.updateModel(model => {
                setFiasAddressToModel(model, nextValue, fiasProps);
            });
        });
    },
    onClick: () => externalOnClickHandler(dispatch, fiasProps.bindingPath),
});

export const FiasContainer = withFocusOnNextValueEditor(
    withResolvePaths(
        withViewModelSelect(
            withFocusManagement(
                connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(withControlDebugInfo(withTestPageObjectRegistration(Fias))),
                fiasComponentIdExtractor()
            )
        )
    )
);
